import "../../components/global.js";
import "../../assets/css/bootstrap.css";
import Navbar from "../../components/Navbar";
import { tokens, GET, format_date, loading } from "../../components/CustomComponent.js";
import React, { Component } from "react";
import Pagination from '@mui/material/Pagination';

export default class Logfile extends Component {
  state = { page: 1, search: "", data: null };

  async componentDidMount() {
    loading(false);
    await this.GetAll();
  }

  GetAll = async () => {
    loading(true);
    let result = await GET(tokens, `v1/TH/document-manage/log/filter-search/page/${this.state.page}`, { data_search: this.state.search });
    if (result?.status) this.setState({ data: result.data });
    loading(false);
  };

  render() {
    const { data, page, search } = this.state;
    return (
      <div className="w-100 min-vh-100 fade-in">
        <Navbar page1="หน้าหลัก" page2="ตั้งค่า" page3="รหัสบัญชี" />
        <div className="body">
            <div className="p-3">
          <div className="card border-0 p-3">
            <h4 className="mb-3"><b>ล็อกไฟล์</b></h4>
            <div className="d-flex align-items-center mb-3">
              <input type="search" className="form-control wpx-200 bg-contain border-0 mx-1" placeholder="พิมพ์คำค้นหา..." value={search} onChange={(e) => this.setState({ search: e.target.value })} />
              <button className="btn btn-primary px-3 mx-1" onClick={() => this.setState({ page: 1 }, this.GetAll)}>ค้นหา</button>
              <button className="btn btn-outline-primary px-3 mx-1" onClick={() => this.setState({ search: "", page: 1 }, this.GetAll)}>รีเซ็ท</button>
            </div>
            
            <div className="table-responsive">
              <table className="table table-borderless table-striped">
                <thead>
                  <tr className="bg-dark-blue text-white">
                    {["วันที่ / เวลา", "ผู้ใช้งาน", "เมนู", "เลขที่เอกสาร", "รายการ"].map(h => <th key={h} className="text-left">{h}</th>)}
                  </tr>
                </thead>
                <tbody>
                  {!data?.data?.length ? (
                    <tr><td colSpan={5} className="text-center">ไม่มีข้อมูล</td></tr>
                  ) : (
                    data.data.map((item, i) => (
                      <tr key={i}>
                        <td>{item.datetime_create ? format_date(item.datetime_create, "dd/mm/yyyy hh:mm:ss") : "-"}</td>
                        <td>{item.full_name || "-"}</td>
                        <td>{item.menu || "-"}</td>
                        <td>{item.document_number || "-"}</td>
                        <td>{item.event_detail || "-"}</td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>

            {data?.data?.length > 0 && (
              <div className="d-flex justify-content-between px-3">
                <label>แสดง {data.end_index} รายการ จาก {data.count} รายการ</label>
                <Pagination count={data.page_number} page={page} color="primary" showFirstButton showLastButton onChange={(_, v) => this.setState({ page: v }, this.GetAll)} />
              </div>
            )}
          </div></div>
        </div>
      </div>
    );
  }
}